import React, { useState } from "react";

import "./index.scss";
import Components from "./Components";
import Context from "../../context";
import {
  BreadCrumb,
  CustomView,
  Pagination,
  TableHeader,
  TableLoading,
} from "../../components";
import values from "../../values";
import constants from "../../values/constants";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";

type Props = {
  rqUser: any;
};

const TicketScreen = (props: Props) => {
  const { data, status } = props.rqUser;

  const { requestTicket, setRequestTicket } = React.useContext(
    Context.TicketScreen
  );

  const writePermission = Cookies.get(
    constants.USER.WRITE_PERMISSION
  )?.toString();

  const { t } = useTranslation();

  return (
    <CustomView.Container id="super-agent-screen-container">
      <CustomView.Row className="table-options-wrapper">
        <CustomView.Column
          extraLarge={3}
          large={5}
          medium={5}
          className="bread-crumb-wrapper"
        >
          <BreadCrumb />
        </CustomView.Column>
        <CustomView.Column
          extraLarge={4}
          large={5}
          medium={7}
          className="search-and-filter-wrapper"
        >
          {writePermission === "true" && <Components.Create />}
          <Components.Filter />
          <Components.Search />
        </CustomView.Column>
      </CustomView.Row>
      <div className="table-content-wrapper">
        <table>
          <TableHeader
            headers={values.tableHeaders.Ticket_HEADERS.map((item) => t(item))}
          />
          {status === "loading" ? (
            <TableLoading />
          ) : (
            <Components.Body data={data?.result?.docs} />
          )}
        </table>
      </div>
      {status === "success" &&
        data?.result?.totalDocs >
          values.constants.PANEL_TABLE_DEFAULT_LIMIT && (
          <div className="pagination">
            <Pagination
              page={requestTicket?.page}
              totalPages={data?.result?.totalPages}
              onPaginate={(page: number) =>
                setRequestTicket!({ ...requestTicket, page })
              }
            />
          </div>
        )}
      {writePermission === "true" && <Components.Update />}
      <Components.ShowInfoTicket />
    </CustomView.Container>
  );
};

export default TicketScreen;
